export enum TransactionIdScopeType {
  PageScope = "PageScope",
  SystemScope = "SystemScope",
}
